export default class AtvFamiliasDetailsController {
    constructor($q, $state, $filter, UIService, AuthorizationService, AtvFamilia, AtvSubfamilia, AtvTipoAtivo, AtvAtivo) {
        this.$q = $q;
        this.state = $state;
        this.filter = $filter;
        this.UI = UIService;
        this.AuthorizationService = AuthorizationService;
        this.AtvFamilia = AtvFamilia;
        this.AtvSubfamilia = AtvSubfamilia;
        this.AtvTipoAtivo = AtvTipoAtivo;
        this.AtvAtivo = AtvAtivo;
        this.loaded = false;
        this.familia = null;
        // Default opt state - populate later when we have all states
        // this.optTiposAtivo = {
        //   total: 0,
        //   start: 0,
        //   end: 0,
        //   page: 1,
        //   items: 10,
        //   order: "designacao",
        //   sort: "asc",
        //   filter: {}
        // };
        // this.tiposAtivo = null;
        // this.tiposAtivoLoading = true;
        this.id = $state.params.id;
        if (angular.isUndefined($state.params.id) || isNaN($state.params.id)) {
            this.state.go('app.ativos.familias.list');
            this.UI.addToast('Familia desconhecida/inválida');
        }
        else {
            this.loadData();
        }
        this.subfamiliasOptions = {
            containment: 'parent',
            tolerance: 'pointer',
            handle: '.pmd-move-handle',
            'ui-floating': true,
            stop: (e, ui) => {
                for (let i = 0; i < this.familia.subfamilias.length; i++) {
                    this.familia.subfamilias[i].ordem = i + 1;
                    this.AtvSubfamilia.upsert(this.familia.subfamilias[i]).$promise.then((res) => {
                    }).catch((error) => {
                        console.log(error);
                        this.UI.addToast("Não foi possível reordenar subfamílias. Por favor tente mais tarde");
                        this.loadData();
                    });
                }
            }
        };
    }
    loadData = () => {
        this.loaded = false;
        this.AtvFamilia.findOne({
            filter: {
                where: {
                    id: this.id,
                    active: true
                },
                include: [{
                        relation: 'subfamilias',
                        scope: {
                            where: {
                                active: 1
                            },
                            order: 'ordem ASC',
                            // include: {
                            //   relation: 'tiposAtivo',
                            //   scope: {
                            //     fields: {id: true},
                            //     where: {
                            //       active: 1
                            //     },
                            //     order: 'designacao ASC',
                            //   }
                            // }
                        }
                    }]
            }
        }).$promise.then((familia) => {
            this.familia = familia;
            this.loaded = true;
        }).catch((error) => {
            console.log(error);
            this.state.go('app.ativos.familias.list');
            this.UI.addToast('Erro a carregar dados de família.');
        });
        // this.getTiposAtivoForFamilia();
    };
    editFamilia = () => {
        let options = {
            size: 'lg',
            template: require('./details.dialog.html'),
            controller: ['$dialog', '$scope', (dialog, scope) => {
                    scope.title = "Editar Família";
                    scope.familia = angular.copy(this.familia);
                    scope.ok = () => {
                        dialog.close(scope);
                    };
                    scope.cancel = () => {
                        dialog.dismiss('cancel');
                    };
                }]
        };
        let modal = this.UI.showDialog(options);
        modal.then((res) => {
            if (res && res.familia) {
                this.AtvFamilia.upsert(res.familia).$promise.then((res) => {
                    this.UI.addToast("Família editada com sucesso");
                    this.loadData();
                }).catch((error) => {
                    console.log(error);
                    this.UI.addToast("Erro na edição de família. Por favor tente mais tarde.");
                });
            }
        });
    };
    editObservations = () => {
        let obs = angular.copy(this.familia.observacoes);
        let dialog = this.UI.showDialog({
            size: 'lg',
            template: require('./observations.dialog.html'),
            controller: ['$scope', $scope => {
                    $scope.observacoes = obs;
                    $scope.ok = () => $scope.$close($scope.observacoes);
                    $scope.cancel = () => $scope.$dismiss('cancel');
                }]
        });
        dialog.then(res => {
            this.loaded = false;
            this.familia.observacoes = res;
            this.familia.$save().then(() => {
                this.UI.addToast('Observações guardadas com sucesso');
                this.loadData();
            }).catch(() => {
                this.UI.addToast('Ocorreu um erro a guardar as observações. Por favor tente mais tarde.');
                this.loadData();
            });
        });
    };
    addSubfamilia = () => {
        let options = {
            size: 'lg',
            template: require('./subfamilia.new.dialog.html'),
            controller: ['$dialog', '$scope', (dialog, scope) => {
                    scope.title = "Nova Subfamília";
                    scope.subfamilia = {};
                    scope.ok = () => {
                        dialog.close(scope);
                    };
                    scope.cancel = () => {
                        dialog.dismiss('cancel');
                    };
                }]
        };
        let modal = this.UI.showDialog(options);
        modal.then((res) => {
            if (res && res.subfamilia) {
                res.subfamilia.id = 0;
                res.subfamilia.familiaId = this.familia.id;
                res.subfamilia.active = 1;
                this.AtvSubfamilia.count({
                    where: {
                        familiaId: this.familia.id,
                        active: 1
                    }
                }).$promise.then((n) => {
                    res.subfamilia.ordem = n.count + 1;
                    this.AtvSubfamilia.create(res.subfamilia).$promise.then((res) => {
                        this.UI.addToast("Subfamília criada com sucesso");
                        this.loadData();
                    }).catch((error) => {
                        console.log(error);
                        this.UI.addToast("Erro na criação de subfamília. Por favor tente mais tarde.");
                    });
                }).catch((error) => {
                    console.log(error);
                    this.UI.addToast("Erro na criação de subfamília. Por favor tente mais tarde");
                });
            }
        });
    };
    editSubfamilia = (r) => {
        let options = {
            size: 'lg',
            template: require('./subfamilia.new.dialog.html'),
            controller: ['$dialog', '$scope', (dialog, scope) => {
                    scope.title = "Editar Subfamília";
                    scope.subfamilia = angular.copy(r);
                    scope.ok = () => {
                        dialog.close(scope);
                    };
                    scope.cancel = () => {
                        dialog.dismiss('cancel');
                    };
                }]
        };
        let modal = this.UI.showDialog(options);
        modal.then((res) => {
            if (res && res.subfamilia) {
                this.AtvSubfamilia.upsert(res.subfamilia).$promise.then((res) => {
                    this.UI.addToast("Subfamília editada com sucesso");
                    this.loadData();
                }).catch((error) => {
                    console.log(error);
                    this.UI.addToast("Erro na edição de subfamília. Por favor tente mais tarde.");
                });
            }
        });
    };
    checkDeleteSubfamilia = (f) => {
        let cenas = this.UI.showWaiting();
        this.AtvSubfamilia.findOne({
            filter: {
                where: {
                    id: f.id,
                    active: 1
                }
            }
        }).$promise.then((subfamiliaToRemove) => {
            // Find if we have something that might block deletion
            this.AtvAtivo.count({
                fields: { id: true },
                where: {
                    active: 1,
                    subfamiliaId: subfamiliaToRemove.id
                }
            }).$promise.then((ativos) => {
                cenas.close();
                if (ativos.count > 0) {
                    let msg = "Não é possível remover subfamília.\nExiste" + (ativos.count > 1 ? "m " : " ");
                    msg += ativos.count > 0 ? (ativos.count + " ativo" + (ativos.count !== 1 ? "s " : " ")) : "";
                    msg += "associado" + (ativos.count > 1 ? "s" : "") + " a esta subfamília.";
                    this.UI.showAlert(msg);
                }
                else {
                    this.confirmDeleteSubfamilia(f);
                }
            }).catch((error) => {
                console.log(error);
                this.UI.addToast("De momento não é possível remover subfamília. Por favor tente mais tarde");
            });
        }).catch(error => {
            console.log(error);
            this.UI.addToast("De momento não é possível remover subfamília. Por favor tente mais tarde");
        });
    };
    confirmDeleteSubfamilia = (f) => {
        let title = "Eliminar Subfamília";
        let warning = "Tem a certeza que pretende remover esta subfamília?";
        let instance = this.UI.showDialog({
            size: 'lg',
            template: require('../../../interface/modals/delete-selected.html'),
            controller: ['$scope', function ($scope) {
                    $scope.title = title;
                    $scope.message = warning;
                    $scope.ok = function () {
                        $scope.$close();
                    };
                    $scope.cancel = function () {
                        $scope.$dismiss('cancel');
                    };
                }]
        });
        instance.then(() => {
            this.removeSubfamilia(f);
        }, (err) => {
            if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
                console.log(err);
        });
    };
    removeSubfamilia = (f) => {
        this.loaded = false;
        // Find again familia to delete so we can update it
        this.AtvSubfamilia.findOne({
            filter: {
                where: {
                    id: f.id,
                    active: 1
                }
            }
        }).$promise.then((subfamiliaToRemove) => {
            subfamiliaToRemove.active = 0;
            subfamiliaToRemove.$save().then((res) => {
                this.AtvSubfamilia.find({
                    filter: {
                        where: {
                            familiaId: this.familia.id,
                            active: 1
                        },
                        order: 'ordem ASC'
                    }
                }).$promise.then((subfams) => {
                    let tasks = [];
                    for (let i = 0; i < subfams.length; i++) {
                        subfams[i].ordem = i + 1;
                        let defer = this.AtvSubfamilia.upsert(subfams[i]).$promise;
                        tasks.push(defer.promise);
                    }
                    this.$q.all(tasks).then((res) => {
                        this.UI.addToast("Subfamília eliminada com sucesso!");
                        this.loadData();
                    }).catch(err => {
                        console.log(err);
                    });
                }).catch((error) => {
                    console.log(error);
                });
            }, (error) => {
                console.log(error);
                this.loaded = false;
                this.UI.addToast("Erro de eliminação. Por favor tente mais tarde.");
            });
        }).catch((error) => {
            console.log(error);
            this.UI.addToast("Não foi possível eliminar a subfamília. Verifique se ainda existe.");
            this.loadData();
        });
    };
}
AtvFamiliasDetailsController.$inject = ['$q', '$state', '$filter', 'UIService', 'AuthorizationService', 'AtvFamilia', 'AtvSubfamilia', 'AtvTipoAtivo', 'AtvAtivo'];
